import { Pick } from "@/components/movements/TransactionFormDialog";
import { SEMI_PRESETS } from "@/lib/scheduled";

const DAYS = Array.from({ length: 31 }, (_, i) => ({ value: String(i + 1), label: i === 30 ? "Último del mes" : String(i + 1) }));
export const CUSTOM = "custom";
export const semiValue = (days?: number[] | null) => {
  const d = [...(days ?? [15, 31])].sort((a, b) => a - b);
  return SEMI_PRESETS.find((p) => p.days[0] === d[0] && p.days[1] === d[1])?.value ?? CUSTOM;
};

interface Props { preset: string; a: string; b: string; onChange: (k: "semi" | "semiA" | "semiB", v: string) => void }

export function SemiDays({ preset, a, b, onChange }: Props) {
  return (
    <div className="space-y-3" data-testid="sch-semi-days">
      <Pick label="¿Qué días?" value={preset} onChange={(v) => onChange("semi", v)} testId="sch-semi-preset" placeholder="Días"
        options={[...SEMI_PRESETS.map((p) => ({ value: p.value, label: p.label })), { value: CUSTOM, label: "Elegir dos días" }]} />
      {preset === CUSTOM && (
        <div className="grid grid-cols-2 gap-3">
          <Pick label="Primer día" value={a} onChange={(v) => onChange("semiA", v)} testId="sch-semi-a" placeholder="Día" options={DAYS.slice(0, 30)} />
          <Pick label="Segundo día" value={b} onChange={(v) => onChange("semiB", v)} testId="sch-semi-b" placeholder="Día" options={DAYS} />
        </div>
      )}
      <p className="text-xs text-slate-500">Siempre dos pagos al mes. Si un día no existe en el mes (por ejemplo, 30 en febrero), se usa el último día.</p>
    </div>
  );
}
